function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => {
      if(
          button.getAttribute('aria-controls') === 'FooterMobileCountryList' ||
          button.getAttribute('aria-controls') === 'FooterMobileLanguageList'
      ) return;
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      $('.header__search_barr').removeAttr('open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');

    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
  //  this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateBarecode();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData()?.find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateBarecode() {
    document.querySelector('.pdp-barcode span').innerText = this.currentVariant.barcode;
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    addButton.classList.remove('disabled');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      let __price =  $('.product__info-container .price__container .price__regular .price-item--regular').text;
      let _sale = $('.product__info-container .price__container .price__sale .price-item--sale');
      if(_sale.length) {
        __price = _sale.text();
      }
      if($('.pdp_promo').length){
        __price += $('.pdp_promo').text();
      }
      addButtonText.textContent = window.variantStrings.addToCart + ' - ' + __price;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)?.product?.variants;
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.optionSelectors = this.querySelectorAll('.option-selector');
    this.data = this.getProductData();
    setTimeout(() => {
      this.updateSortVariant();
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateSortVariant(){
    if(this.optionSelectors){
      this.optionSelectors.forEach((selector) => {
        const _option =  selector.dataset.option;
        const __option =  this.data.option_name;
        const _values = this.data.options_with_values.reduce(function(acc, item) {
          return acc !== false ? acc : item.name.toLowerCase() === _option ? item.values : false;
        }, false);

        const _sort = this.data.sort_variant_option_values.reduce(function(acc, item) {
          return acc !== false ? acc : item.option_name === __option ? item : false;
        }, false);

        if(_values && _sort){
          _values.sort(function(a, b) { return a.localeCompare(b)});
          _values.sort((a, b) => a - b);
          if(_sort.custom_values && _sort.custom_values.length) {
            _values.sort((a, b) => _sort.custom_values.indexOf(a) - _sort.custom_values.indexOf(b));
          }

          const _content = selector.querySelector('.option-selector__btns');
          _values.forEach((val) => {
            const _val = val.replaceAll('"', '').toLowerCase();
            const _input = selector.querySelector(`input[data-swatch2="${_val}"]`);

            const _label = selector.querySelector(`label[data-swatch2="${_val}"]`);
            if(_input && _label){
              _content.appendChild(_input);
              _content.appendChild(_label);
            }
          });
        }
          selector.classList.remove('loading');
      });    
    }
  }

  getProductData() {
    const dataEl = this.querySelector('[type="application/json"]');
    return JSON.parse(dataEl.textContent);
  }

}

customElements.define('variant-radios', VariantRadios);

$(document).ready(function(){
  $('.header-menu-li1').on('mouseenter', function () {
    $('.header-menu-li1.parent').removeClass('open');
    if ($(this).hasClass('parent')) {
      $(this).addClass('open');
      $('sticky-header').addClass('menu-open');
      $('.announcement-bar').addClass('menu-open');
    } else {
      $('sticky-header').removeClass('menu-open');
      $('.announcement-bar').removeClass('menu-open');
    }
  });

  $('.header-menu-li1 .header-menu-li1-bg').on('mouseenter', function () {
    $('.header-menu-li1.parent').removeClass('open');
    $('sticky-header').removeClass('menu-open');
    $('.announcement-bar').removeClass('menu-open');
  });

  $('nav.header---menu').on('mouseleave', function () {
    $('.header-menu-li1.parent').removeClass('open');
    $('sticky-header').removeClass('menu-open');
    $('.announcement-bar').removeClass('menu-open');
  });

  $('.footer-menu-l1').on('click', function () {
      $(this).parent().toggleClass('open');
  });


  $('input[required]').on('invalid', function() {
    if(window.langStore == 'en') {
      this.setCustomValidity('this field is required');
    } else {
      this.setCustomValidity('ce champ est obligatoire');
    }
  });
});

(function ($) {

  var svg_icon = '<svg width="14px" height="8px" viewBox="0 0 14 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n' +
      '    <title>Group 3</title>\n' +
      '    <desc>Created with Sketch.</desc>\n' +
      '    <defs>\n' +
      '        <polygon id="path-1" points="0 4.9122807e-05 7.79402729 4.9122807e-05 7.79402729 13.8722807 0 13.8722807"></polygon>\n' +
      '    </defs>\n' +
      '    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
      '        <g id="Header-search" transform="translate(-1846.000000, -124.000000)">\n' +
      '            <g id="Group-3" transform="translate(1853.000000, 128.000000) rotate(-270.000000) translate(-1853.000000, -128.000000) translate(1849.000000, 121.000000)">\n' +
      '                <mask id="mask-2" fill="white">\n' +
      '                    <use xlink:href="#path-1"></use>\n' +
      '                </mask>\n' +
      '                <g id="Clip-2"></g>\n' +
      '                <path d="M1.05793372,13.8723298 L7.57520468,7.45689123 C7.8671345,7.16903158 7.8671345,6.70310175 7.57520468,6.41548772 L1.05793372,4.9122807e-05 L0,1.04145263 L5.98830409,6.93618947 L0,12.8309263 L1.05793372,13.8723298 Z" id="Fill-1" fill="#5E266D" mask="url(#mask-2)"></path>\n' +
      '            </g>\n' +
      '        </g>\n' +
      '    </g>\n' +
      '</svg>'

  var text_en =
      '<p>there’s no better way to spoil someone than to give the gift of choice! from the lingerie lover to the cocooning specialist, a blush gift card is a fun, sexy present. no muss, no fuss!</p>' +
      '<p>you will receive an email confirmation when the card is delivered to the recipient\'s inbox, and they will instantly receive their e-gift. it’s up to them to print it or go the digital way! plus, this gift card never expires, so they can splurge now, or save it for a special occasion!</p>';

  var text_fr =
      '<p>il n’existe pas de meilleure façon de gâter quelqu’un que de lui offrir l’opportunité de choisir! de l’amoureuse de la lingerie à la spécialiste du cocooning, une carte-cadeau blush est un présent amusant et sexy. c’est simple comme ‘bonjour’!</p>' +
      '<p>vous recevrez une confirmation par courriel lorsque la carte sera envoyée à la boîte courriel de son destinataire, qui recevra instantanément son présent électronique. à eux de l’imprimer ou de l’offrir en ligne! de plus, cette carte-cadeau n’expire jamais; ils peuvent donc se gâter maintenant, ou la garder pour une occasion spéciale!</p>';


  $(document).ready(function(){
    setTimeout(function() {
      $('<div class="sc-gift-card-info __close"><h4>description'+ svg_icon +'</h4><div class="sc-gift-card-info__dropdown __close"></div></div>').insertAfter($('.sc-builder .sc-configurator > form'));
      $('.sc-gift-card-info__dropdown').html(window.Shopify.locale === 'en' ? text_en : text_fr);

      $('.sc-card-tab').on('click',function(){
        if($(this).not('.sc-card-tab--active'))
        {
          $('.sc-card-text h4').toggleClass('_hide');
          $('.sc-card-text').first().toggleClass('_hide');
        }
      });

      $('.sc-builder .sc-gift-card .sc-gift-card__container img').css('opacity', '1');

    }, 500);

    var _size_chart_modal = $('.popup-size-chart');
    var _add_arrow = function(){
      if(_size_chart_modal.length) {
        var _table_wrap = _size_chart_modal.find('.sc-content-info .active');
        var _table_sc = _size_chart_modal.find('.sc-content-info .active .sc-table');
        var _is_arrow = _table_wrap.find('.is_arrow');
        if(!_is_arrow.length) {
          var _span = $('<span/>')
              .addClass('is_arrow')
              .insertAfter(_table_wrap.find('.sc-table-wrap'));
        }
        if(_table_sc.width() > _table_wrap.width()){
          _table_wrap.addClass('_is_arrow');
        } else {
          _table_wrap.removeClass('_is_arrow');

        }
      }
    }
    var _header = _size_chart_modal.find('.sc-content-header-buttons button');

    if(_header.length) {
      _header.each(function(){
        $(this).on('click', function(){
          _add_arrow();
        });
      });
    }
    $(window).resize(function(){
      _add_arrow();
    });
    _add_arrow();
  });

})(jQuery);



class ImagesSlider extends HTMLElement {
  constructor() {
    super();
      this.next = this.querySelector('.plp-img-next');
      this.prev = this.querySelector('.plp-img-prev');
      this.next?.addEventListener('click', this.renderSlider.bind(this, 'next'));
      this.prev?.addEventListener('click', this.renderSlider.bind(this, 'prev'));

      let touchstartX = 0;
      let touchendX = 0;
      let touch = false;

      this.querySelector('.first-img')?.addEventListener('touchstart', e => {
          touchstartX = e.changedTouches[0].screenX;
      })

      this.querySelector('.first-img')?.addEventListener('touchend', e => {
          touchendX = e.changedTouches[0].screenX
          if (!touch && touchendX < touchstartX) this.renderSlider('next');
          if (!touch && touchendX > touchstartX) this.renderSlider('prev');
      })
  }

    renderSlider(direction) {
        this.slider = this.querySelector('.plp-product__images');
        this.classList.add('loading');

        this.next.style.display = 'none';
        this.prev.style.display = 'none';
        const slick_arrow_prev = `<button class="plp-img-prev"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="--eq-body-width:1334;"><polygon fill="#333" fill-rule="evenodd" points="10.077 7 9 8.076 13.305 12.381 9 16.687 10.077 17.764 15.457 12.381" transform="rotate(-180 12.229 12.382)"/></svg>prev</button>`;
        const slick_arrow_next = `<button class="plp-img-next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="--eq-body-width:1334;"><polygon fill="#333" fill-rule="evenodd" points="10.077 7 9 8.076 13.305 12.381 9 16.687 10.077 17.764 15.457 12.381"/></svg>next</button>`;

        this.firstImage = this.querySelector('.first-img');
        let srcs_sting = this.firstImage.getAttribute('data-srcs').slice(0, -1);
        let img_alt = this.firstImage.getAttribute('alt');
        let srcs = srcs_sting.split('|');

        let video_sting = this.firstImage.getAttribute('data-video');
        let video = video_sting.split('|');
        let video_url = video[0];
        let video_position = parseInt(video[1]);

        let html_images = ``;
        srcs.map((im_src, i) => {
            if(video_url && video_position && (video_position === i + 1)){
                html_images += `<div class='video-item-slick'><img src='${spotDOM.getSizedImage(window.default_img, "350x500")}'/><video preload='none' alt='${img_alt} - video' autoplay loop muted playsinline><source src='${video_url}' type='video/mp4'></video></div>`;
            }
            html_images += `<img src='${im_src}' alt='${img_alt} ${i}' width='350' height='500'/>`
        })
        if(video_url && video_position && (video_position >= srcs.length + 1)){
            html_images += `<div class='video-item-slick'><img src='${spotDOM.getSizedImage(window.default_img, "350x500")}'/><video preload='none' alt='${img_alt} - video' autoplay loop muted playsinline><source src='${video_url}' type='video/mp4'></video></div>`;
        }
        this.slider.innerHTML += html_images;

        const slider = $(this.slider);
        const this_ = $(this);
        if(!slider.hasClass("slick-initialized")) {
            slider.slick({
                prevArrow: slick_arrow_prev,
                nextArrow: slick_arrow_next,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                draggable: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            draggable: true,
                        }
                    }
                ]
            });
        }

        setTimeout(function() {
            slider.slick('refresh');
        }, 100);

        setTimeout(function() {
           this_.removeClass('loading');
            if (direction === 'prev') { slider.slick('slickPrev') }
                else { slider.slick('slickNext') }
        }, 1000);
    }
}

customElements.define('images-slider', ImagesSlider);

window.initLazyScript = initLazyScript;

function initLazyScript(element, callback, threshold = 0) {
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof callback === 'function') {
            callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, { rootMargin: `0px 0px ${threshold}px 0px` });

    io.observe(element);
  } else {
    callback();
  }
}

document.addEventListener("DOMContentLoaded", () => {

  var formatPrice = function(p) {
    var p_ = '';

    let simbol_ = '$';
    p_ = simbol_+(p/100).toFixed(2);
    if (window.Shopify.locale === 'fr') p_ = (p/100).toFixed(2)+simbol_;
    return p_
  }

  var renderProduct= function (data) {
  
    if (window.Shopify.locale === 'fr' && data.title === 'carte-cadeau électronique') {
      data.image1 = 'https://cdn.shopify.com/s/files/1/0635/6834/7374/files/image_gift_card_fr.jpg?v=1707845423';
      data.image2 = 'https://cdn.shopify.com/s/files/1/0635/6834/7374/files/image_gift_card_fr.jpg?v=1707845423'
    };
    var price_ = '';
    var add_b = '';
    if (data.price_min < data.price) {
      price_ = '<span class="pr-price-old">'+formatPrice(data.price)+'</span>';
      price_ += '<span class="pr-price-new">'+formatPrice(data.price_min)+'</span>';
    } else {
      price_ = '<span class="pr-price-regular">'+formatPrice(data.price)+'</span>';
    }

    var _add = window.Shopify.locale === "fr" ? "add to bag" : "ajouter";

    if (data.variant_id) {
        add_b ='<div class="cart-add-v"><button data-color="'+ data.option_color +'" data-group-id="'+ data.group_id +'" data-variant-id="'+ data.variant_id +'">' + _add + '</button></div>';
    }

    let promo_text = data.promo_text;

    return `<div class="item-product">
          <a href="${data.url}" class="rp-images">
              <img class="image-1" src="${data.image1}" alt="${data.title}">
              <img class="image-2" src="${data.image2}" alt="${data.title}">
          </a>
          <div class="rp-title">
              <a href="${data.url}">${data.title}</a>
          </div>
          <div class="rp-price">${price_} ${promo_text}</div>
          ${add_b}
      </div>`
  }

  var getProductApi = function(handle, _content) {
    $.ajax({
      url: `${window.Shopify.routes.root}products/${handle}?view=get-product`,
      success: function(product) {
        var product_json = JSON.parse(product);
        if (product_json) _content.innerHTML = renderProduct(product_json);
      }
    });
  }

  var _items =  document.querySelectorAll('.bggle--slider .bggle_product-container');
  if(_items.length){
    _items.forEach((bggleItem) => {
      var _item =  bggleItem.getAttribute('bggle-product-handle');
      if(_item){
        const _content = document.createElement('div');
        _content.classList.add('featured-collection__info');
        bggleItem.appendChild(_content);
        getProductApi(_item, _content);
      }
    });
  }
});


(function () {
  var TRUSTPILOT_SELECTOR = '.trustpilot-widget';
  var PROCESSED_ATTR = 'data-trustpilot-customized';
  var CUSTOM_ATTRIBUTES = {
    'data-star-color': '#000000',
    'data-font-family': 'Apercu',
    'data-text-color': '#000000',
    'data-text-transform': 'lowercase'
  };

  function customizeWidget(widget) {
    // Guard against the observer re-processing a widget (Trustpilot mutates the
    // widget itself when it injects its iframe), which would loop forever.
    if (!widget || widget.hasAttribute(PROCESSED_ATTR)) return;

    Object.keys(CUSTOM_ATTRIBUTES).forEach(function (name) {
      widget.setAttribute(name, CUSTOM_ATTRIBUTES[name]);
    });

    // Only reaches the markup outside the cross-origin iframe (see note above).
    widget.style.textTransform = 'lowercase';

    widget.setAttribute(PROCESSED_ATTR, 'true');

    // If the Trustpilot bootstrap has not loaded yet it will render the widget
    // itself, picking up the attributes we just set.
    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        window.Trustpilot.loadFromElement(widget, true);
    }
  }

  function customizeWithin(root) {
    
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(TRUSTPILOT_SELECTOR)) customizeWidget(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(TRUSTPILOT_SELECTOR).forEach(customizeWidget);
    }
  }

  function customizeAll() {
    document.querySelectorAll(TRUSTPILOT_SELECTOR).forEach(customizeWidget);
  }

  customizeAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', customizeAll);
  }
  window.addEventListener('load', customizeAll);

  // Sections re-rendered in the theme editor / by section rendering.
  document.addEventListener('shopify:section:load', function (event) {
    customizeWithin(event.target);
  });

  // Catch-all for app blocks and any other markup added after page load.
  if (window.MutationObserver && document.body) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(customizeWithin);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

